import React, { useEffect, useState } from "react";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import API from "../Services/MachineMaster";
import API1 from '../Services/Product'
import APIS from '../Services/SalesTab'
import APISS from "../Services/Location";
import APISSS from '../Services/ProductType'

import ProductType from "../Components/ProductType";
const ProductMachineMappingList = () => {
    const perPage = 10;

    const [productList, setProductList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [rows, setRows] = useState([]);
    const [location, setLocation] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [qty, setQty] = useState("")
    const [comboPrice, setComboPrice] = useState("")
    const [comboSpecialPrice, setComboSpecialPrice] = useState(0);
    const [error, setError] = useState({});
    const [comboName, setComboName] = useState("")
    const [timeOptions, setTimeOptions] = useState([]);
    const [currentPage1, setCurrentPage1] = useState(1);
    const [totalRecords1, setTotalRecords1] = useState(0);
    const [isModal, setIsModal] = useState(false)
    const [searchProductList, setSearchProductList] = useState([])
    const [searchProductType, setSearchProductType] = useState([])
    const [selectedLocation1, setSelectedLocation1] = useState("")
    const productTypeFlag = false;
    const productTypeFlag2 = 'All';
    const [refresh, setRefresh] = useState(true);
    const [isAddProductList, setIsAddProductList] = useState(true);
    const staticHours = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    const staticMinutes = ["0", "15", "30", "45",];
    const [comboProductType, setComboProductType] = useState([])
    const [selectedcomboProductType, setSelectedcomboProductType] = useState([])
    const [showComboModal1, setShowComboModal1] = useState(false);
    const [selectcomboSalesTab, setSelectcomboSalesTab] = useState("")
    const [salesTab1, setSalesTab1] = useState([])
    const [location1, setLocation1] = useState([])
    const [mrp, setMrp] = useState("");
    const [id, setId] = useState([])
    const [viewData, setViewData] = useState(null);
    useEffect(() => {
        getMachineProductList();
        bindLocation();
    }, [currentPage]);

    useEffect(() => {
        if (searchProductType) {
            handleSearch(searchProductType, currentPage1);
        }
    }, [currentPage1]);


    const handleSearch = async (product_type_id, page) => {
        if (!product_type_id || product_type_id.length === 0) {
            return;
        }
        setIsModal(true);
        const payload = {
            limit: perPage,
            pageNumber: page,
            product_type_id: product_type_id,
        };
        try {
            const response = await API1.Get_Product(payload);

            if (response.data && response.data.data) {
                setSearchProductList(response.data.data);
                setTotalRecords1(response.data.totalCount);
                setIsModal(true);
            } else {
                toast.error("No data found.");
            }
        } catch (error) {
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            console.error('Error fetching products:', error);
            toast.error("An error occurred while searching for products.");
        }
    };
    const handleSearchClick = () => {
        if (!searchProductType || searchProductType.length === 0) {
            toast.error("Please select a Product Type.");
            return;
        }
        handleSearch(searchProductType, currentPage1);
    };
    const bindLocation = async () => {
        try {
            const response = await APISS.getLocationList({
                is_active: 1,
                limit: 0,
            });

            setLocation(response?.data?.data || []);
            setLocation1(response?.data?.data || [])
        } catch (error) {
            console.error(error);

            if (error?.response?.status === 403) {
                window.location.replace("/Login");
            }
        }
    };

    const getMachineProductList = async () => {
        try {
            const payload = {};

            const response = await API.getMachineComboProduct(payload);
            setProductList(response?.data?.data || []);
            setTotalRecords(response?.data?.total_count || 0);
        } catch (error) {
            toast.dismiss();

            if (!error.response) {
                toast.error(
                    "Network error! Please check your internet connection"
                );
            } else if (error.response.status === 403) {
                window.location.replace("/Login");
                toast.error("Unauthorized access.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };

    const bindComboProduct = async (salesTabId) => {
        try {
            const payload = {
                limit: 0,
                is_Active: 1,
                is_combo: true,
                sale_tab_id: salesTabId
            };
            const response = await APISSS.Get_Product_Type(payload);
            //console.log('dddddd',response?.data?.data)
            setComboProductType(response?.data?.data);
        } catch (error) {
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching combo product:", error);
        }
    };
    const totalPages = Math.ceil(totalRecords / perPage);

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };
    const handleFieldChange1 = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "comboName":
                setComboName(value);
                break;
            case "comboProductType":
                setComboProductType(value);
                break;

            case "comboPrice":
                setComboPrice(value);
                break;

            default:
                break;
        }
    };

    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];

        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);

            if (left > 2) {
                pageNumbers.push(1, "...");
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }

            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }

            if (right < totalPages - 1) {
                pageNumbers.push("...", totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }

        return pageNumbers;
    };

    const handleChange3 = (e) => {
        setRefresh(false);
        const value = e.target.value;
        setSelectedLocation1(value);
        getSalesTab1(value)
        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.salesTab;
            return updatedErrors;
        });
    };
    const handleChange2 = (e) => {
        const value = e.target.value;
        if (value === 'Select') {
            setSelectcomboSalesTab(0);
        } else {
            setSelectcomboSalesTab(value);
            bindComboProduct(value)

        }

        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.salesTab;
            return updatedErrors;
        });
    };
    const getSalesTab1 = async (location) => {
        try {
            if (location === "Select") {

                setSalesTab1([]);
                return;
            }
            const response = await APIS.Sales_Tab_List({
                is_active: 1,
                limit: 10,
                pageNumber: 1,
                search: location,
            });
            setSalesTab1(response?.data?.data || []);
            setRefresh(true);
        } catch (error) {
            setError((prev) => ({ ...prev, salesTab: "Failed to fetch sales tab data." }));
            handleError(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };

    const handleInputChange = (index, field, value) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, [field]: value } : row
        );
        setRows(updatedRows);

        if (field === "discounted_price" || field === "qty") {
            const total = updatedRows.reduce((sum, row) => {
                const price = parseFloat(row.discounted_price || 0);
                const qty = parseFloat(row.qty);
                const validQty = isNaN(qty) || qty === 0 ? 1 : qty;
                const rowTotal = price * validQty;
                return sum + (isNaN(rowTotal) ? 0 : rowTotal);
            }, 0);

            setComboPrice(total.toFixed(2));
        }
        if (field === "discounted_price_special" || field === "qty") {
            const total = updatedRows.reduce((sum, row) => {
                const price = parseFloat(row.discounted_price_special || 0);
                const qty = parseFloat(row.qty);
                const validQty = isNaN(qty) || qty === 0 ? 1 : qty;

                const rowTotal = price * validQty;
                return sum + (isNaN(rowTotal) ? 0 : rowTotal);
            }, 0);

            setComboSpecialPrice(total.toFixed(2));
        }
    };
    const validateFields1 = () => {
        const errors = {};
        if (!comboName.trim()) errors.comboName = "Name is required";
        if (!comboPrice.trim()) {
            errors.comboPrice = "Price is required";
        } else if (isNaN(comboPrice)) {
            errors.comboPrice = "Price must be a valid number";
        } else if (parseFloat(qty) <= 0) {
            errors.comboPrice = "Price must be greater than 0";
        }
        setError(errors);
        return Object.keys(errors).length === 0;
    };

    const recalculateComboPrices = (rowsData) => {
        const totalNormal = rowsData.reduce((sum, row) => {
            const price = parseFloat(row.discounted_price || 0);
            const qty = parseFloat(row.qty || 1);
            return sum + price * (qty === 0 ? 1 : qty);
        }, 0);

        const totalSpecial = rowsData.reduce((sum, row) => {
            const price = parseFloat(row.discounted_price_special || 0);
            const qty = parseFloat(row.qty || 1);
            return sum + price * (qty === 0 ? 1 : qty);
        }, 0);

        setComboPrice(totalNormal.toFixed(2));
        setComboSpecialPrice(totalSpecial.toFixed(2));
    };

    const handleRemoveRow = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);
        recalculateComboPrices(updatedRows)
    };

    const handleAddRow = async (id, productName, time, type) => {
        // console.log('cll whn up');
        const isAlreadyAdded = rows.some(row => row.id === id);
        if (isAlreadyAdded) {
            toast.error("Product already added");
            return;
        }
      //  console.log(time);
        if (type === 'up') {
            try {
                const response = await API1.getSubProduct(id);
               // console.log("response data product data update..", response?.data)
                const details = response?.data?.data?.rows || [];
                if (details.length === 0) {
                    console.warn("No sub-products found");
                    return;
                }
                const newRows = details.map(item => {
                    const totalMinutes = item.time ?? null;

                    const hours = totalMinutes !== null ? Math.floor(totalMinutes / 60) : "";
                    const minutes = totalMinutes !== null ? totalMinutes % 60 : "";

                    return {
                        id: item.product_id,
                        productName: item.product_name,
                        time: totalMinutes ?? 0, // keep numeric for logic check
                        hours,
                        minutes,
                        qty: item.quantity ?? "0",
                        discounted_price: item.offered_price,
                        discounted_price_special: item.special_price
                    };
                });
                setRows(prevRows => [...prevRows, ...newRows]);
                console.log('newRows', newRows);
            } catch (error) {
                console.error("Error fetching sub-products:", error);
            }
        } else {
            const newRow = {
                id: id,
                productName: productName,
                time: time,
                quantity: "",
            };
            //console.log("new row...", newRow)
            toast.success('Product Added Successfully');
            setRows(prevRows => [...prevRows, newRow]);
        }
    }
    const getTimeData = async () => {
        try {
            const response = await API.getTime();
            setTimeOptions(response?.data?.data || []);
        } catch (error) {
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching time data:", error);
        }
    };
    const handleGetData = async (id) => {
        // console.log('id', id);

        const response = await API.getMachineComboProduct({
            id: id
        })

        const fetchDetails = response?.data?.data?.[0];
        // console.log('ddd1111', response?.data?.data?.[0])
        //  handleAddRow(fetchDetails.id, '', '', 'up')
        if (!fetchDetails) return;
        setViewData(fetchDetails);
        setId(id);
        setComboName(fetchDetails.combo_name);
        setComboPrice(fetchDetails.amount);
        setComboSpecialPrice(fetchDetails.special_price);
        const rowData = fetchDetails.sub_products.map(item => ({
            id: item.id,
            productId: item.product_id,
             product_name: item.product_name,
            qty: item.quantity,
            time: item.time,
            discounted_price: item.offered_price,
            discounted_price_special: item.special_price,
            hours: Math.floor(item.time / 60),
            minutes: item.time % 60
        }));
        setRows(rowData);
    }

    const totalPages1 = Math.ceil(totalRecords1 / perPage);
    const handlePageChange1 = (page) => {
        if (page > 0 && page <= totalPages1) {
            setCurrentPage1(page);
            handleSearch(searchProductType);
            //getProductList();
        }
    };
    const handleCancel = () => {
        window.location.reload();
    }
    const updateProductData = async () => {
        const validateFields = () => {
            const errors = [];

            const isNumeric = (value) =>
                !isNaN(value) && String(value).trim() !== "";

            const isValid = (value) =>
                value !== undefined &&
                value !== null &&
                String(value).trim() !== "";

            if (!comboName) {
                errors.push("Combo Name is required.");
            }

            if (comboProductType === "Select") {
                errors.push("Combo Product Type is required.");
            }

            if (!isValid(comboPrice) || !isNumeric(comboPrice)) {
                errors.push("Combo Price is required and must be a valid number.");
            }

            return errors;
        };

        const errors = validateFields();

        if (errors.length > 0) {
            errors.forEach((error) => toast.error(error));
            return;
        }

        const sub_products = rows.map((row) => ({
            product_id: row.id,
            quantity: parseInt(row.qty, 10) || 0,
            time:
                (parseInt(row.hours || 0, 10) * 60) +
                parseInt(row.minutes || 0, 10) ||
                row.time ||
                0,
            offered_price: parseFloat(row.discounted_price) || 0,
            special_price: parseFloat(row.discounted_price_special) || 0,
        }));

        if (sub_products.length === 0) {
            toast.error("Please select at least one sub-product.");
            return;
        }

        const payload = {
            name: comboName,
            amount: parseInt(comboPrice, 10) || 0,
            mrp: mrp || null,
            special_price: parseFloat(comboSpecialPrice) || 0,
            sub_products,
        };

        try {
            const response = await API.updateMachineCombo(id, payload);
            // console.log('dd',id,payload);
            if (response?.status === 200) {
                toast.success(
                    response?.data?.message ||
                    "Product Status Updated Successfully!"
                );

                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            } else {
                toast.error(
                    response?.data?.message ||
                    "Failed to update Product. Please try again."
                );
            }
        } catch (error) {
            if (error?.response?.status === 403) {
                window.location.replace("/Login");
                return;
            }

            console.error(
                "Error updating product:",
                error?.response?.data?.message
            );

            toast.error(
                error?.response?.data?.message ||
                "Something went wrong. Please try again."
            );
        }
    };
    const handleChange4 = (e) => {
        const value = e.target.value;
        setSelectedcomboProductType(value);
        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.salesTab;
            return updatedErrors;
        });
    };
    const handleError = (error) => {

        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");

        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };

    return (
        <div>
            <div className="col-lg-12 grid-margin stretch-card mt-5">
                <div className="card rounded-0">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">
                            Machine Combo Product List
                        </h4>
                    </div>

                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>Sr No</th>
                                        <th>Action</th>
                                        <th>Combo Name</th>
                                        <th>Amount</th>
                                        <th>Special Price</th>
                                        <th>Status</th>
                                        <th>Created Date</th>
                                        <th>Sub Products</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {productList.length > 0 ? (
                                        productList.map((item, index) => (
                                            <tr key={item.id}>
                                                <td>
                                                    {(currentPage - 1) *
                                                        perPage +
                                                        index +
                                                        1}
                                                </td>
                                                <td>
                                                    <ul className="navbar-nav navbar-nav-right">
                                                        <li className="nav-item nav-profile1">
                                                            <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <div className="nav-profile-text1">
                                                                    <p className="mb-1 text-black">
                                                                    </p>
                                                                </div>
                                                            </span>
                                                            <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                            <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalView">
                                                                        View
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)}
                                                                        className="btn btn-primary btn-sm" type="button"
                                                                        data-bs-toggle="modal" data-bs-target="#myModal"
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                {/* <a className="dropdown-item">

                                                                    <button
                                                                        className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                        onClick={() => changeStatus(item.id, item.is_active)}
                                                                    >
                                                                        {item.is_active ? "De-Activate" : "Activate"}
                                                                    </button>

                                                                </a> */}
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </td>

                                                <td>{item.combo_name}</td>

                                                <td>₹{item.amount}</td>

                                                <td>
                                                    ₹{item.special_price}
                                                </td>

                                                <td>
                                                    {item?.is_active ? "Active" : "De-Activated"}
                                                </td>

                                                <td>
                                                    {moment(item.createdAt).format("DD-MM-YYYY")}
                                                    {/* {moment(
                                                        item.createdAt
                                                    ).format(
                                                        "DD-MM-YYYY hh:mm A"
                                                    )} */}
                                                </td>

                                                <td>
                                                    <table className="table table-sm table-bordered mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    Product ID
                                                                </th>
                                                                <th>Qty</th>
                                                                <th>
                                                                    Offered
                                                                    Price
                                                                </th>
                                                                <th>
                                                                    Special
                                                                    Price
                                                                </th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {item.sub_products?.map(
                                                                (sub) => (
                                                                    <tr
                                                                        key={
                                                                            sub.id
                                                                        }
                                                                    >
                                                                        <td>
                                                                            {
                                                                                sub.product_id
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                sub.quantity
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            ₹
                                                                            {
                                                                                sub.offered_price
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            ₹
                                                                            {
                                                                                sub.special_price
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7">
                                                No Records Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            {productList.length > 0 && totalPages > 1 && (
                                <nav aria-label="Page navigation">
                                    <ul className="pagination justify-content-center mt-4">
                                        <li
                                            className={`page-item ${currentPage === 1
                                                ? "disabled"
                                                : ""
                                                }`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() =>
                                                    handlePageChange(
                                                        currentPage - 1
                                                    )
                                                }
                                            >
                                                Previous
                                            </button>
                                        </li>

                                        {getPageNumbers().map(
                                            (page, index) => (
                                                <li
                                                    key={index}
                                                    className={`page-item ${page === currentPage
                                                        ? "active"
                                                        : ""
                                                        } ${page === "..."
                                                            ? "disabled"
                                                            : ""
                                                        }`}
                                                >
                                                    {page === "..." ? (
                                                        <span className="page-link">
                                                            ...
                                                        </span>
                                                    ) : (
                                                        <button
                                                            className="page-link"
                                                            onClick={() =>
                                                                handlePageChange(
                                                                    page
                                                                )
                                                            }
                                                        >
                                                            {page}
                                                        </button>
                                                    )}
                                                </li>
                                            )
                                        )}

                                        <li
                                            className={`page-item ${currentPage === totalPages
                                                ? "disabled"
                                                : ""
                                                }`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() =>
                                                    handlePageChange(
                                                        currentPage + 1
                                                    )
                                                }
                                            >
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="myModal" data-bs-backdrop="static">
                <div className="modal-dialog modal-lg" style={{ border: "1px solid" }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Edit Machine Combo Product</h5>

                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">

                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="ddSalesType" className="form-label">
                                            Location <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <select className="form-select"
                                            id="ddSalesType"
                                            value={selectedLocation1}
                                            onChange={handleChange3}
                                        >
                                            <option>Select </option>
                                            {location1.map((item) => (

                                                <option key={item.id} value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </select>
                                        {error.location && <small className="text-danger">{error.location}</small>}
                                    </div>

                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="ddSalesType" className="form-label">
                                            Sales Tab <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <select className="form-select"
                                            id="ddSalesType"
                                            value={selectcomboSalesTab}
                                            onChange={handleChange2}
                                        >
                                            <option>Select</option>
                                            {salesTab1.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.tab_name}
                                                </option>
                                            ))}
                                        </select>
                                        {error.salesTab && <small className="text-danger">{error.salesTab}</small>}
                                    </div>
                                </div>
                                <div className="col-md-4">

                                    <div className="form-group">
                                        <label htmlFor="ddSalesType" className="form-label">
                                            Product Type <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <select
                                            className="form-select"
                                            id="ddSalesType"
                                            value={selectedcomboProductType}
                                            onChange={handleChange4}
                                        >
                                            <option>Select</option>
                                            {Array.isArray(comboProductType) && comboProductType.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </select>
                                        {error.comboProductType && <small className="text-danger">{error.comboProductType}</small>}
                                    </div>

                                </div>
                                <div className="col-md-5">
                                    <div className="form-group">

                                        <label htmlFor="name">Name <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtname"
                                            placeholder="Name"
                                            value={comboName}
                                            onChange={(e) => handleFieldChange1(e, "comboName")}
                                        />
                                        {error.comboName && <small className="text-danger">{error.comboName}</small>}
                                    </div>
                                </div>



                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="mobile">Price  <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtprice"
                                            placeholder="Price"
                                            disabled={true}
                                            value={comboPrice}
                                            onChange={(e) => handleFieldChange1(e, "comboPrice")}
                                        />
                                        {error.comboPrice && <small className="text-danger">{error.comboPrice}</small>}
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="mobile">Special Price <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtSpecialPrice"
                                            placeholder="Special Price"
                                            value={comboSpecialPrice}
                                            disabled={true}
                                            onChange={(e) => handleFieldChange1(e, "comboSpecialPrice")}
                                        />
                                        {error.comboSpecialPrice && <small className="text-danger">{error.comboSpecialPrice}</small>}
                                    </div>
                                </div>
                            </div>
                            {isAddProductList && (
                                <section >
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="table-responsive">
                                                <table className="table table-bordered text-center align-middle" style={{ width: "120%" }}>
                                                    <thead className="table-dark">
                                                        <tr>
                                                            <th style={{ width: "50px" }}>Action</th>
                                                            <th style={{ width: "150px" }}>Product Name</th>
                                                            <th style={{ width: "250px" }}>Time</th>
                                                            <th style={{ width: "100px" }}>Qty</th>
                                                            <th style={{ width: "30px" }}>Discounted Price</th>
                                                            <th style={{ width: "30px" }}>Discounted Price(SPCL)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {rows.map((row, index) => (
                                                           
                                                            <tr key={index}>
                                                                <td>
                                                                    <button
                                                                        className="btn btn-danger btn-sm"
                                                                        onClick={() => handleRemoveRow(index)}
                                                                        style={{ backgroundColor: "red" }}
                                                                    >
                                                                        <span className="fa fa-trash-o text-white"></span>
                                                                    </button>
                                                                </td>
                                                                <td>{row.product_name}</td>
                                                                <td>
                                                                    {row.time > 0 ? (
                                                                        <span>{`${row.time % 60} min`}</span>
                                                                    ) : (
                                                                        <div className="row">
                                                                            <div className="col-md-6">
                                                                                <div className="form-group">
                                                                                    <label>Enter Hours</label>
                                                                                    <select
                                                                                        className="form-select"
                                                                                        value={row.hours}
                                                                                        onChange={(e) => handleInputChange(index, "hours", e.target.value)}
                                                                                    >
                                                                                        {staticHours.map((hour) => (
                                                                                            <option key={hour} value={hour}>
                                                                                                {hour} hrs
                                                                                            </option>
                                                                                        ))}
                                                                                    </select>
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-md-6">
                                                                                <div className="form-group">
                                                                                    <label htmlFor="ddltime" className="form-label">
                                                                                        Enter Minute
                                                                                    </label>
                                                                                    <select
                                                                                        className="form-select"
                                                                                        id="ddltime"
                                                                                        value={row.minutes}
                                                                                        onChange={(e) => handleInputChange(index, "minutes", e.target.value)}
                                                                                    >
                                                                                        {staticMinutes.map((minute) => (
                                                                                            <option key={minute} value={minute}>
                                                                                                {minute} min
                                                                                            </option>
                                                                                        ))}
                                                                                    </select>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </td>

                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter Quantity"
                                                                        value={row.qty}
                                                                        onChange={(e) => handleInputChange(index, "qty", e.target.value)}
                                                                    />
                                                                    {error.qty && <small className="text-danger">{error.qty}</small>}
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Discounted Price"
                                                                        value={row.discounted_price}
                                                                        onChange={(e) => handleInputChange(index, "discounted_price", e.target.value)}
                                                                    />
                                                                    {error.discounted_price && <small className="text-danger">{error.discounted_price}</small>}
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Discounted Price Special"
                                                                        value={row.discounted_price_special}
                                                                        onChange={(e) => handleInputChange(index, "discounted_price_special", e.target.value)}
                                                                    />
                                                                    {error.discounted_price_special && <small className="text-danger">{error.discounted_price_special}</small>}
                                                                </td>
                                                            </tr>
                                                        ))}

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <h5>Add SubProduct</h5>
                                        <div className="col-md-4">
                                            {
                                                refresh ?
                                                    <ProductType selectedProductType={searchProductType} setSelectedProductType={setSearchProductType} type={productTypeFlag2}
                                                        location_id={selectedLocation1}
                                                    />
                                                    : <></>
                                            }
                                        </div>
                                        <div className="col-md-3">
                                            <button className="btn btn-success mt-4"
                                                type="button"
                                                onClick={handleSearchClick}
                                            >Search</button>
                                        </div>
                                    </div>
                                </section>


                            )}
                            {/* Yaha */}
                            <div className="mt-1"> <button type="button" className="btn btn-primary me-2"
                                onClick={updateProductData}
                            >
                                Update
                            </button>

                                <button className="btn btn-light"
                                    // onClick={handleCancel}
                                    data-bs-dismiss="modal"
                                >Cancel</button></div>


                        </div>
                    </div>
                </div>
            </div>

            {isModal && (
                <>
                    <div className="modal-backdrop show" style={{ filter: "blur(5px)" }}></div>
                    <section>
                        <div className="modal show d-block" style={{ backgroundColor: "#f2edf3" }} tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered modal-lg" style={{ width: "600px" }}>
                                <div className="modal-content" style={{ backgroundColor: "#fff" }} >
                                    <div className="modal-header">
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setIsModal(false)}></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="table-responsive">
                                            <table className="table table-bordered text-center">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: "100px" }}>SrNo</th>
                                                        <th style={{ width: "200px" }}>Action</th>
                                                        <th>Product Name</th>
                                                        <th>Time</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {searchProductList.map((item, index) => (

                                                        <tr key={item.id}>
                                                            <td>{(currentPage1 - 1) * perPage + index + 1}</td>
                                                            <td>
                                                                <button className="btn btn-sm btn-success" onClick={() => handleAddRow(item.id, item.name, item.time, 'down')}>Add</button>
                                                            </td>
                                                            <td>{item.name}</td>
                                                            <td>{item.time}</td>

                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            <nav aria-label="Page navigation example">
                                                <ul className="pagination justify-content-center mt-4">
                                                    <li className={`page-item ${currentPage1 === 1 ? "disabled" : ""}`}>
                                                        <button className="page-link" onClick={() => handlePageChange1(currentPage1 - 1)} disabled={currentPage1 === 1}>Previous</button>
                                                    </li>
                                                    {Array.from({ length: totalPages1 }, (_, index) => (
                                                        <li key={index + 1} className={`page-item ${currentPage1 === index + 1 ? "active" : ""}`}>
                                                            <button className="page-link" onClick={() => handlePageChange1(index + 1)}>{index + 1}</button>
                                                        </li>
                                                    ))}
                                                    <li className={`page-item ${currentPage1 === totalPages1 ? "disabled" : ""}`}>
                                                        <button className="page-link" onClick={() => handlePageChange1(currentPage1 + 1)} disabled={currentPage1 === totalPages1}>Next</button>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => setIsModal(false)}>Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}
            <section>
                <div className="modal" id="myModalView">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Machine Combo Product Details</h4>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                ></button>
                            </div>

                            <div className="modal-body">
                                <table className="table table-bordered border-secondary">
                                    <tbody>
                                        <tr>
                                            <th>Combo Name</th>
                                            <th>Amount</th>
                                            <th>Special Price</th>
                                        </tr>
                                        <tr>
                                            <td>{viewData?.combo_name}</td>
                                            <td>₹ {viewData?.amount}</td>
                                            <td>₹ {viewData?.special_price}</td>
                                        </tr>

                                        <tr>
                                            <th>Status</th>
                                            <th>Created Date</th>
                                            {/* <th>Total Products</th> */}
                                        </tr>
                                        <tr>
                                            <td>
                                                {viewData?.is_active
                                                    ? "Active"
                                                    : "De-Activated"}
                                            </td>
                                            <td>
                                                {moment(viewData?.createdAt).format(
                                                    "DD-MM-YYYY"
                                                )}
                                            </td>
                                            {/* <td>
                                                {viewData?.sub_products?.length || 0}
                                            </td> */}
                                        </tr>
                                    </tbody>
                                </table>

                                <h6 className="mt-3">Sub Product Details</h6>

                                <table className="table table-bordered border-secondary">
                                    <thead>
                                        <tr>
                                            <th>Product Id</th>
                                            <th>Qty</th>
                                            <th>Time</th>
                                            <th>Offer Price</th>
                                            <th>Special Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {viewData?.sub_products?.map((item) => (
                                            <tr key={item.id}>
                                                <td>{item.product_id}</td>
                                                <td>{item.quantity}</td>
                                                <td>{item.time}</td>
                                                <td>₹ {item.offered_price}</td>
                                                <td>₹ {item.special_price}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="modal-footer"></div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ProductMachineMappingList;